import axios from 'axios';
import { API_BASE_URL } from '../../config/apiConfig';

const base = `${API_BASE_URL}/Purchase`;

/** Item category master used to scope the item search */
export const getItemCategories = () =>
    axios.get(`${base}/Getitemcategories`);

/** Prefix search — Typ: '1' = by Item Code, '2' = by Item Name; Cat: selected category id */
export const autoCompleteItem = (pfx, typ, cat) =>
    axios.get(`${base}/AutoCompleteitem`, { params: { Pfx: pfx, Typ: typ, Cat: cat } });

/** Current item details (name, basic price, HSN, specification, units) for a given item code */
export const getViewItemCodeUpdation = (itemcode) =>
    axios.get(`${base}/GetViewItemCodeUpdation`, { params: { Itemcode: itemcode } });

/** HSN codes selectable for this item (its DCA-scoped HSN list) */
export const getHsnUpd = (itemcode) =>
    axios.get(`${base}/GetHsnupd`, { params: { Itemcode: itemcode } });

/** All unit-of-measure options */
export const getAllUnitsUpd = () =>
    axios.get(`${base}/GetAllUnitsupd`);

/** Pre-submit gate — rejects if the item already has a pending update/approval */
export const itemCodeCheckPendings = (itemCode) =>
    axios.post(`${base}/ItemCodeCheckPendings`, { ItemCode: itemCode });

/** Submit the item code update for approval */
export const saveItemCodeUpdateDetails = (payload) =>
    axios.post(`${base}/SaveItemCodeUpdateDetails`, payload);
